import { useLayoutEffect, useState } from 'react'

export default function useIsTouchDevice() {
    const [isTouchDevice, setIsTouchDevice] = useState(false)

    useLayoutEffect(() => {
        function onResize() {
            setIsTouchDevice(
                'ontouchstart' in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.maxTouchPoints > 0,
            )
        }

        window.addEventListener('resize', onResize)
        onResize()

        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])

    return isTouchDevice
}